import * as React from 'react';
import tw from 'twin.macro';
import 'styled-components/macro';

export interface DotProps extends React.HTMLAttributes<HTMLDivElement> {
  isCurrent?: boolean;
}

export const Dot = ({ isCurrent, ...forwardedProps }: DotProps) => (
  <div
    css={[
      tw`cursor-pointer flex-shrink-0 h-full relative w-4`,
      !isCurrent && tw`opacity-20 hover:opacity-100`,
      `scroll-snap-align: start;`,
    ]}
    {...forwardedProps}
  >
    <div
      css={[
        tw`absolute border-1 border-white box-content h-2 left-1/2 rounded-full top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-2`,
        !isCurrent && tw`invisible`,
      ]}
    />
    <div tw="absolute bg-white block h-half left-1/2 rounded-full top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-half" />
  </div>
);
